import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./fileUpdateLayout.scss";
import useAuth from "../../hooks/useAuth.js";
import useAxios from "../../hooks/useAxios";

const FileUpdateLayout = ({ children, guid }) => {
	const { auth } = useAuth();
	const { operation } = useAxios();

	// TODO: 這是什麼
	//後台登入帳號控制
	// console.log(guid);
	// const [isSwiftAdmin, setSwiftAdmin] = useState(false);
	// useEffect(() => {
	//     guid === '90277a3e-8b1f-ed11-a178-00155d070709' && setSwiftAdmin(true);
	// }, [guid]);

	// console.log('FileUpdateLayout');

	//sideBar active控制
	const [simplePage, setSimplePage] = useState("");
	const [appGuid, setAppGuid] = useState("");
	const [osCode, setOsCode] = useState("");
	const [otaGuid, setOtaGuid] = useState("");
	const [otaType, setOtaType] = useState("");
	const [scheduleGuid, setScheduleGuid] = useState("");

	console.log(scheduleGuid);

	const [appList, setAppList] = useState([]);
	const [oSList, setOSList] = useState([]);
	const [otaList, setOtaList] = useState([]);
	const [actRegistrationList, setActRegistrationList] = useState([]);

	useEffect(() => {
		let simplePageList = [
			// 系統設定 - app基本設定,ota基本設定,權限設定
			"appMainUpdate",
			"OTAMainUpdate",
			"authUpdate",

			// 用户管理
			"usersUpdate",

			// 網站管理
			"exploreupdate",
			"newsupdate",
			"physicalstoreupdate",
			"downloadcenterupdate",
			"questionupdate",
			"questioncategoryupdate",

			// 球譜管理
			"userDrill",
			"userDrillClass",
			"presetDrill",
			"drillCategoryUpdate",

			// 發球機生管
			"productionRecord",
			"factoryRecord",

			// 活動管理
			"actactivity",
			"actRegistration",

			// 商品管理
			"salSalesKitClass",
			"salSalesKitAppendix",
			"salSalesKit",

			// 訂單管理
			"invoice",
		];

		simplePageList.forEach((page) => {
			if (window.location.pathname.includes(page)) {
				setSimplePage(page);
			}
		});

		// APP管理
		if (window.location.pathname === "/appupdate") {
			setAppGuid(
				window.location.search.split("?")[1].split("&")[0].split("=")[1]
			);
			setOsCode(
				window.location.search.split("?")[1].split("&")[1].split("=")[1]
			);
		}

		// OTA管理
		if (window.location.pathname === "/otafirmwareupdate") {
			setOtaGuid(
				window.location.search.split("?")[1].split("&")[0].split("=")[1]
			);
			setOtaType(
				window.location.search.split("?")[1].split("&")[1].split("=")[1]
			);
		}

		// OTA管理
		if (window.location.pathname === "/otaaudioupdate") {
			setOtaGuid(
				window.location.search.split("?")[1].split("&")[0].split("=")[1]
			);
			setOtaType(
				window.location.search.split("?")[1].split("&")[1].split("=")[1]
			);
		}
	}, [window.location.search, window.location.pathname]);

	const getAppList = async () => {
		const { success, response, error } = await operation(
			{
				url: "/sys/app",
			},
			"getAppList"
		);

		if (success) {
			const reverseList = response.data.result.reverse(function (a, b) {
				return a.updateTIme > b.updateTIme;
			});

			setAppList(reverseList);
		}

		if (error) {
			console.log(error);
		}
	};

	const getOSList = async () => {
		const { success, response, error } = await operation(
			{
				url: "/sys/oSofapp",
			},
			"getOSList"
		);

		if (success) {
			setOSList(response.data.result);
		}

		if (error) {
			console.log(error);
		}
	};

	const getOtaList = async () => {
		const { success, response, error } = await operation(
			{
				url: "/sys/ota",
			},
			"getOtaList"
		);

		if (success) {
			response.data.result.reverse(function (a, b) {
				return a.updateTIme > b.updateTIme;
			});
			setOtaList(response.data.result);
		}

		if (error) {
			console.log(error);
		}
	};

	const getActRegistrationList = async () => {
		const { success, response, error } = await operation(
			{
				url: "/actregistration/getschedulesidebar",
			},
			"getActRegistrationList"
		);

		if (success) {
			// console.log(response);
		}

		if (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		getAppList();
		getOSList();
		getOtaList();
		//getActRegistrationList();
	}, []);

	return (
		//是否為後台管理員
		<div className={`container-fluid bg-background p-0`}>
			<div className="container-custom">
				<div className="row py-5">
					<div className="col-3 bg-background">
						<section className="w-100" id="section-sidebar">
							<Accordion
							// defaultActiveKey='0'
							>
								{auth?.permissionList?.includes("authSystem") && (
									<Accordion.Item eventKey="0">
										<Accordion.Header>
											<span className="circleIcon me-2"></span>
											系統設定
										</Accordion.Header>
										<Link to="/appMainUpdate">
											<Accordion.Body
												className={`ms-0 ${simplePage === "appMainUpdate" && "active"
													}`}
											>
												<span className="me-2">-</span>
												APP基本設定
											</Accordion.Body>
										</Link>
										<Link to="/OTAMainUpdate">
											<Accordion.Body
												className={`ms-0 ${simplePage === "OTAMainUpdate" && "active"
													}`}
											>
												<span className="me-2">-</span>
												OTA基本設定
											</Accordion.Body>
										</Link>
										{/*<Link to="/authUpdate">*/}
										{/*	<Accordion.Body*/}
										{/*		className={`ms-0 ${simplePage === "authUpdate" && "active"*/}
										{/*			}`}*/}
										{/*	>*/}
										{/*		<span className="me-2">-</span>*/}
										{/*		權限設定*/}
										{/*	</Accordion.Body>*/}
										{/*</Link>*/}
									</Accordion.Item>
								)}
								{/* APP管理 */}
								{auth?.permissionList?.includes("authApp") && (
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											<span className="circleIcon me-2"></span>
											APP管理
										</Accordion.Header>

										{appList.sort((a, b) => new Date(b.updateTime) - new Date(a.updateTime)).map((el) => (
											<Accordion.Body
												key={el.appGuid}
												className={`manageView pingtexApp p-0 m-0`}
											>
												<div
													className="header"
													onClick={(e) => {
														e.target.nextSibling.classList.toggle("d-none");
													}}
												>
													<span className="me-2">-</span>
													{el.name}
												</div>

												<div
													className={
														appGuid === el.appGuid ? "d-block" : "d-none"
													}
												>
													{oSList.map((item) => (
														<Link
															key={item.name}
															to={`/appupdate?appguid=${el.appGuid}&oscode=${item.osCode}&appname=${el.name}`}
														>
															<Accordion.Body
																className={`ps-5 ${appGuid === el.appGuid &&
																	osCode === item.osCode &&
																	"active"
																	}`}
															>
																{item.name}
															</Accordion.Body>
														</Link>
													))}
												</div>
											</Accordion.Body>
										))}
									</Accordion.Item>
								)}
								{/* OTA管理 */}
								{auth?.permissionList?.includes("authOta") && (
									<Accordion.Item eventKey="3">
										<Accordion.Header>
											<span className="circleIcon me-2"></span>
											韌體OTA管理
										</Accordion.Header>

										{otaList.map((el) => (
											<Accordion.Body
												key={el.otaGuid}
												className={`manageView OTAManage p-0 m-0`}
											>
												<div
													className="header"
													onClick={(e) => {
														e.target.nextSibling.classList.toggle("d-none");
													}}
												>
													<span className="me-2">-</span>
													{el.name}
												</div>

												<div
													className={
														otaGuid === el.otaGuid ? "d-block" : "d-none"
													}
												>
													<Link
														to={`/otafirmwareupdate?otaguid=${el.otaGuid}&otaType=firmware&machineName=${el.name}`}
													>
														<Accordion.Body
															className={`ps-5 ${otaGuid === el.otaGuid &&
																otaType === "firmware" &&
																"active"
																}`}
														>
															firmware
														</Accordion.Body>
													</Link>
													<Link
														to={`/otaaudioupdate?otaguid=${el.otaGuid}&otaType=audio&machineName=${el.name}`}
													>
														<Accordion.Body
															className={`ps-5 ${otaGuid === el.otaGuid &&
																otaType === "audio" &&
																"active"
																}`}
														>
															audio
														</Accordion.Body>
													</Link>
												</div>
											</Accordion.Body>
										))}
									</Accordion.Item>
								)}
							</Accordion>
						</section>
					</div>
					<div className="col-9 bg-background">{children}</div>
				</div>
			</div>
		</div>
	);
};

export default FileUpdateLayout;
